/**
 * API клієнт для ref.nomenclature_retail_prices (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/nomenclature-retail-prices.
 * Permissions: retail.nomenclature_prices.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export interface NomenclatureRetailPrice {
  id: string;
  organization_id: string;
  nomenclature_id: string;
  price_group_id: string;
  price: string;
  vat_included: boolean;
  valid_from: string;
  valid_to: string | null;
  is_active: boolean;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface NomenclatureRetailPriceCreate {
  organization_id: string;
  nomenclature_id: string;
  price_group_id: string;
  price: string;
  vat_included?: boolean;
  valid_from?: string | null;
  valid_to?: string | null;
  is_active?: boolean;
  comment?: string | null;
}

export type NomenclatureRetailPriceUpdate = Partial<Omit<NomenclatureRetailPriceCreate, 'organization_id' | 'nomenclature_id' | 'price_group_id'>>;

export const retailNomenclaturePrices = {
  list: (params?: {
    organization_id?: string;
    nomenclature_id?: string;
    price_group_id?: string;
    is_active?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<NomenclatureRetailPrice>>('/retail/nomenclature-retail-prices', { params })
      .then((r) => r.data),
  get: (id: string) =>
    api.get<NomenclatureRetailPrice>(`/retail/nomenclature-retail-prices/${id}`).then((r) => r.data),
  create: (payload: NomenclatureRetailPriceCreate) =>
    api.post<NomenclatureRetailPrice>('/retail/nomenclature-retail-prices', payload).then((r) => r.data),
  update: (id: string, payload: NomenclatureRetailPriceUpdate) =>
    api.patch<NomenclatureRetailPrice>(`/retail/nomenclature-retail-prices/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/retail/nomenclature-retail-prices/${id}`).then(() => undefined),
};
